/**
 * Ins 区块：主列表 Swiper + 弹窗 Swiper（每页整卡切换）
 * 弹窗左侧媒体：打开弹窗或切到含视频的一页后自动播放；双栏模式自动切到视频层（仍可点控件）
 */
(function () {
  /**
   * 解析 metaobject 中 image_data JSON 字符串（[{ url, altText }]），写入 img src / video poster
   */
  /**
   * 从 sources 数组中选可直链播放的 mp4（排除 HLS/m3u8），按 width 取较清晰
   */
  function pickUrlFromSourcesArray(arr) {
    if (!Array.isArray(arr) || !arr.length) return '';
    var best = '';
    var bestW = -1;
    for (var i = 0; i < arr.length; i++) {
      var s = arr[i];
      if (!s || !s.url) continue;
      var mt = String(s.mimeType || s.mime_type || '').toLowerCase();
      if (mt.indexOf('mpegurl') !== -1 || mt.indexOf('m3u8') !== -1) continue;
      if (mt.indexOf('mp4') === -1) continue;
      var w = parseInt(s.width, 10) || 0;
      if (w >= bestW) {
        bestW = w;
        best = s.url;
      }
    }
    return best;
  }

  /**
   * 从 video 元素的 data-src 或 data-video-sources（JSON 数组）得到播放地址
   */
  function isHttpUrl(str) {
    if (!str || typeof str !== 'string') return false;
    str = str.trim();
    return /^https?:\/\//i.test(str) || str.indexOf('//') === 0;
  }

  function applyVideoSrc(videoEl) {
    if (!videoEl) return false;
    if (videoEl.getAttribute('src')) return true;
    var ds = (videoEl.getAttribute('data-src') || '').trim();
    var raw = videoEl.getAttribute('data-video-sources');
    var url = '';
    if (isHttpUrl(ds)) url = ds;
    else if (raw) {
      try {
        var data = JSON.parse(raw);
        if (typeof data === 'string') data = JSON.parse(data);
        var arr = Array.isArray(data) ? data : (data && data.sources) || [];
        url = pickUrlFromSourcesArray(arr);
      } catch (e) {}
    }
    if (!url) return false;
    videoEl.src = url;
    if (typeof videoEl.load === 'function') videoEl.load();
    return true;
  }

  /**
   * 用原生 video.play()；资源未就绪时监听 loadeddata/canplay，异步路径须静音才符合浏览器策略
   * @param {HTMLVideoElement} v
   * @param {boolean} fromUserGesture 是否来自用户直接点播放（同步就绪时可尝试有声）
   */
  function playVideoWithElement(v, fromUserGesture) {
    if (!v) return;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    function runPlay(asyncPath) {
      if (asyncPath || !fromUserGesture) v.muted = true;
      var p = v.play();
      if (p !== undefined && typeof p.then === 'function') {
        p.catch(function () {
          v.muted = true;
          return v.play();
        }).catch(function () {});
      }
    }
    var done = false;
    var fallbackTimer;
    function finish(asyncPath) {
      if (done) return;
      done = true;
      if (fallbackTimer) clearTimeout(fallbackTimer);
      runPlay(asyncPath);
    }
    fallbackTimer = setTimeout(function () {
      finish(true);
    }, 8000);
    if (v.readyState >= 2) {
      finish(false);
      return;
    }
    v.addEventListener('loadeddata', function () {
      finish(true);
    }, { once: true });
    v.addEventListener('canplay', function () {
      finish(true);
    }, { once: true });
  }

  /** 移动端列表缩略图限宽：Shopify / ImageKit 拼 width=，外链不改 */
  function resizeInsThumbUrl(url, width) {
    if (!url || !width) return url;
    try {
      var protocolRelative = url.indexOf('//') === 0;
      var absolute = protocolRelative ? 'https:' + url : url;
      if (!/cdn\.shopify\.com|\.myshopify\.com|imagekit\.io/i.test(absolute)) {
        return url;
      }
      // 去掉旧式 _1000x / _1000x1000 后缀，再统一用 width 参数
      absolute = absolute.replace(/_(?:\d+)x(?:\d+)?(?=\.[^./?#]+(?:\?|$))/i, '');
      var parsed = new URL(absolute);
      parsed.searchParams.set('width', String(width));
      return protocolRelative ? parsed.href.replace(/^https?:/, '') : parsed.href;
    } catch (e) {
      return url;
    }
  }

  function hydrateInsImageJson(scope, options) {
    if (!scope || !scope.querySelectorAll) return;
    options = options || {};
    // thumbs: 仅列表缩略图；modal: 仅弹窗内图/poster；all: 全部
    var mode = options.mode || 'all';
    var isMobile = window.innerWidth < 750;
    scope.querySelectorAll('[data-ins-image-json]').forEach(function (el) {
      var isThumb = el.classList.contains('ins-section__thumb-img');
      if (mode === 'thumbs' && !isThumb) return;
      if (mode === 'modal' && isThumb) return;
      var raw = el.getAttribute('data-ins-image-json');
      if (!raw) return;
      try {
        var arr = JSON.parse(raw);
        if (!Array.isArray(arr) || !arr.length || !arr[0] || !arr[0].url) return;
        var src = arr[0].url;
        // 仅移动端列表缩略图限宽；PC / 弹窗封面保持原图
        if (isMobile && isThumb) {
          src = resizeInsThumbUrl(src, 480);
        }
        el.setAttribute('src', src);
        var alt = arr[0].altText || arr[0].alt;
        if (alt) el.setAttribute('alt', String(alt));
        el.removeAttribute('data-ins-image-json');
      } catch (err) {}
    });
    // poster 只在弹窗场景写入，避免初始化时抢下原图
    if (mode === 'thumbs') return;
    scope.querySelectorAll('[data-ins-poster-json]').forEach(function (el) {
      var raw = el.getAttribute('data-ins-poster-json');
      if (!raw) return;
      try {
        var arr = JSON.parse(raw);
        if (!Array.isArray(arr) || !arr.length || !arr[0] || !arr[0].url) return;
        el.setAttribute('poster', arr[0].url);
        el.removeAttribute('data-ins-poster-json');
      } catch (err2) {}
    });
  }

  /** 重置所有条：退出播放态、停视频、卸 src */
  function resetAllModalMedia(modalEl) {
    modalEl.querySelectorAll('.ins-section-modal__media-inner').forEach(function (inner) {
      inner.classList.remove('ins-section-modal__media-inner--playing');
    });
    modalEl.querySelectorAll('video.ins-section-modal__video').forEach(function (v) {
      v.pause();
      v.removeAttribute('src');
    });
  }

  /** 当前条：有视频则写入 src 并自动播放（纯视频 / 双栏均处理） */
  function syncModalMedia(modalEl, activeIndex) {
    resetAllModalMedia(modalEl);
    var slides = modalEl.querySelectorAll('.ins-section-modal-swiper .swiper-slide');
    var slide = slides[activeIndex];
    if (!slide) return;
    // 打开/切换到该页时再加载弹窗原图，避免与列表 480 图重复抢带宽
    hydrateInsImageJson(slide, { mode: 'modal' });
    var inner = slide.querySelector('.ins-section-modal__media-inner');
    if (!inner) return;
    var v = slide.querySelector('video.ins-section-modal__video');
    if (!v) return;
    if (inner.classList.contains('ins-section-modal__media-inner--video-only')) {
      if (!applyVideoSrc(v)) return;
      playVideoWithElement(v, false);
      return;
    }
    if (inner.classList.contains('ins-section-modal__media-inner--dual')) {
      inner.classList.add('ins-section-modal__media-inner--playing');
      if (!applyVideoSrc(v)) {
        inner.classList.remove('ins-section-modal__media-inner--playing');
        return;
      }
      playVideoWithElement(v, false);
    }
  }

  /** 弹窗右侧文案：超出预设高度时显示「...Expand」，展开后显示「Close」 */
  function updateCaptionWrapState(wrapEl) {
    var inner = wrapEl.querySelector('[data-ins-caption-inner]');
    var btn = wrapEl.querySelector('[data-ins-caption-toggle]');
    if (!inner || !btn) return;

    if (wrapEl.classList.contains('is-expanded')) {
      wrapEl.classList.add('ins-section-modal__caption-wrap--has-fade');
      btn.hidden = false;
      btn.textContent = 'Close';
      btn.setAttribute('aria-expanded', 'true');
      return;
    }

    var overflow = inner.scrollHeight > inner.clientHeight + 2;
    btn.hidden = !overflow;
    btn.textContent = '...Expand';
    btn.setAttribute('aria-expanded', 'false');
    wrapEl.classList.toggle('ins-section-modal__caption-wrap--has-fade', overflow);
  }

  function getActiveModalSlideEl(modalEl, swiperInst) {
    if (!modalEl) return null;
    if (swiperInst && swiperInst.slides && swiperInst.slides.length) {
      var i = swiperInst.activeIndex;
      if (typeof i === 'number' && swiperInst.slides[i]) return swiperInst.slides[i];
    }
    return modalEl.querySelector('.ins-section-modal-swiper .swiper-slide-active');
  }

  function syncModalCaptionClamps(modalEl, resetExpanded, swiperInst) {
    if (!modalEl) return;
    var activeSlideEl = getActiveModalSlideEl(modalEl, swiperInst);
    modalEl.querySelectorAll('[data-ins-caption-wrap]').forEach(function (wrap) {
      var slide = wrap.closest('.swiper-slide');
      var isActive = !!(activeSlideEl && slide === activeSlideEl);
      var btn = wrap.querySelector('[data-ins-caption-toggle]');
      if (!isActive) {
        if (resetExpanded) wrap.classList.remove('is-expanded');
        if (btn) btn.hidden = true;
        wrap.classList.remove('ins-section-modal__caption-wrap--has-fade');
        return;
      }
      if (resetExpanded) wrap.classList.remove('is-expanded');
      requestAnimationFrame(function () {
        updateCaptionWrapState(wrap);
      });
    });
  }

  /** 双栏（封面+视频）：点击播放后切到视频层 */
  function onModalPlayClick(modalEl, playBtn) {
    var inner = playBtn.closest('.ins-section-modal__media-inner');
    if (!inner || !inner.classList.contains('ins-section-modal__media-inner--dual')) return;
    var v = inner.querySelector('video.ins-section-modal__video');
    if (!v) return;
    inner.classList.add('ins-section-modal__media-inner--playing');
    if (!applyVideoSrc(v)) {
      inner.classList.remove('ins-section-modal__media-inner--playing');
      return;
    }
    playVideoWithElement(v, true);
  }

  /** 加购结果文案（与 buy-buttons / product-form 行为对齐：loading + 通知抽屉或 cart-notification） */
  function setAddCartFeedback(buttonEl, message, kind) {
    var wrap = buttonEl.closest('.ins-section-modal__product');
    if (!wrap) return;
    var el = wrap.querySelector('[data-ins-add-cart-feedback]');
    if (!el) return;
    if (!message) {
      el.hidden = true;
      el.textContent = '';
      el.classList.remove('ins-section-modal__add-cart-feedback--ok', 'ins-section-modal__add-cart-feedback--err');
      return;
    }
    el.textContent = message;
    el.hidden = false;
    el.classList.toggle('ins-section-modal__add-cart-feedback--ok', kind === 'ok');
    el.classList.toggle('ins-section-modal__add-cart-feedback--err', kind === 'err');
    clearTimeout(el._insHideT);
    el._insHideT = setTimeout(function () {
      el.hidden = true;
      el.textContent = '';
      el.classList.remove('ins-section-modal__add-cart-feedback--ok', 'ins-section-modal__add-cart-feedback--err');
    }, 4000);
  }

  function addToCart(variantId, buttonEl, sectionRoot) {
    if (!variantId) return;
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var spinner = buttonEl.querySelector('.loading__spinner');
    var successNote =
      (sectionRoot && sectionRoot.getAttribute && sectionRoot.getAttribute('data-cart-added-text')) || '';
    var fallbackErr =
      (sectionRoot && sectionRoot.getAttribute && sectionRoot.getAttribute('data-cart-fallback-error')) ||
      'Error';

    buttonEl.classList.add('loading');
    buttonEl.setAttribute('aria-disabled', 'true');
    if (spinner) spinner.classList.remove('hidden');
    setAddCartFeedback(buttonEl, '', '');

    var requestBody = {
      items: [{ id: Number(variantId), quantity: 1 }]
    };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      requestBody.sections = cart.getSectionsToRender().map(function (s) {
        return s.id || s.section || s;
      });
      requestBody.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(requestBody)
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || err.message || 'cart');
          });
        }
        return res.json();
      })
      .then(function (response) {
        if (response.status) {
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'ins-section',
              productVariantId: variantId,
              errors: response.errors || response.description,
              message: response.message
            });
          }
          setAddCartFeedback(
            buttonEl,
            response.description || response.message || fallbackErr,
            'err'
          );
          return;
        }

        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'ins-section',
            productVariantId: variantId,
            cartData: response
          });
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        Qmsg.success('Item added to your cart');
        if (cart && typeof cart.renderContents === 'function') {
          var defaultItem =
            (response.items &&
              response.items.find(function (item) {
                return item.requires_shipping;
              })) ||
            (response.items && response.items[0]);
          if (defaultItem && defaultItem.key) {
            cart.renderContents(Object.assign({}, response, { key: defaultItem.key }));
          } else {
            cart.renderContents(response);
          }
        } else if (window.routes && window.routes.cart_url) {
          window.location.href = window.routes.cart_url;
        } else if (successNote) {
          setAddCartFeedback(buttonEl, successNote, 'ok');
        }
      })
      .catch(function (err) {
        setAddCartFeedback(buttonEl, (err && err.message) || fallbackErr, 'err');
      })
      .finally(function () {
        buttonEl.classList.remove('loading');
        buttonEl.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      });
  }

  /** 初始化跑马灯（CSS 动画，非 Swiper） */
  function initMarquee(marqueeEl) {
    var speed = Number(marqueeEl.dataset.insMarqueeSpeed);
    var track = marqueeEl.querySelector('.ins-section-marquee__track');
    if (!track) return;
    var safeSpeed = Number.isFinite(speed) && speed > 0 ? speed : 28;
    track.style.setProperty('--ins-marquee-duration', safeSpeed + 's');
  }

  function initSection(root) {
    // 初始化只加载列表缩略图；弹窗原图等打开后再加载，避免与 480 缩略图重复请求
    hydrateInsImageJson(root, { mode: 'thumbs' });

    var marqueeEl = root.querySelector('[data-ins-marquee]');
    if (marqueeEl) {
      initMarquee(marqueeEl);
    }

    if (typeof window.Swiper === 'undefined') return;
    var sectionId = root.dataset.sectionId;
    var modal = document.getElementById('ins-section-modal-' + sectionId);
    if (!modal) return;

    var mainEl = root.querySelector('[data-ins-main-swiper]');
    var modalSwiperEl = modal.querySelector('[data-ins-modal-swiper]');

    var mainSwiper = null;
    var modalSwiper = null;

    if (mainEl) {
      mainSwiper = new window.Swiper(mainEl, {
        slidesPerView: 4,
        spaceBetween: 40,
        slidesPerGroup: 1,
        watchOverflow: true,
        navigation: {
          nextEl: mainEl.querySelector('.swiper-button-next'),
          prevEl: mainEl.querySelector('.swiper-button-prev')
        },
        breakpoints: {
          0: { slidesPerView: 2, spaceBetween: 12 },
          750: { slidesPerView: 3, spaceBetween: 14 },
          990: { slidesPerView: 4, spaceBetween: 30 }
        }
      });
    }

    if (modalSwiperEl) {
      modalSwiper = new window.Swiper(modalSwiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 400,
        navigation: {
          nextEl: modal.querySelector('.ins-section-modal__nav--next'),
          prevEl: modal.querySelector('.ins-section-modal__nav--prev')
        },
        keyboard: { enabled: true },
        on: {
          slideChange: function () {
            syncModalMedia(modal, modalSwiper.activeIndex);
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                syncModalCaptionClamps(modal, true, modalSwiper);
              });
            });
          },
          slideChangeTransitionEnd: function () {
            syncModalCaptionClamps(modal, false, modalSwiper);
          }
        }
      });
    }

    function openModal(index) {
      modal.classList.add('is-open');
      document.body.classList.add('modal-open');
      if (modalSwiper) {
        modalSwiper.slideTo(index, 0);
      }
      syncModalMedia(modal, index);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          syncModalCaptionClamps(modal, true, modalSwiper);
        });
      });
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.classList.remove('modal-open');
      resetAllModalMedia(modal);
      modal.querySelectorAll('[data-ins-caption-wrap]').forEach(function (w) {
        w.classList.remove('is-expanded', 'ins-section-modal__caption-wrap--has-fade');
        var b = w.querySelector('[data-ins-caption-toggle]');
        if (b) b.hidden = true;
      });
    }

    root.querySelectorAll('[data-ins-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-ins-open'), 10) || 0;
        openModal(idx);
      });
    });

    modal.querySelectorAll('[data-ins-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    if (!modal._insCaptionResizeBound) {
      modal._insCaptionResizeBound = true;
      var captionResizeTimer;
      window.addEventListener(
        'resize',
        function () {
          if (!modal.classList.contains('is-open')) return;
          clearTimeout(captionResizeTimer);
          captionResizeTimer = setTimeout(function () {
            syncModalCaptionClamps(modal, false, modalSwiper);
          }, 150);
        },
        { passive: true }
      );
    }

    if (typeof ResizeObserver !== 'undefined' && !modal._insAsideRoBound) {
      modal._insAsideRoBound = true;
      var asideRoDeb;
      var asideEl = modal.querySelector('.ins-section-modal__aside');
      if (asideEl) {
        var asideRo = new ResizeObserver(function () {
          if (!modal.classList.contains('is-open')) return;
          clearTimeout(asideRoDeb);
          asideRoDeb = setTimeout(function () {
            syncModalCaptionClamps(modal, false, modalSwiper);
          }, 50);
        });
        asideRo.observe(asideEl);
      }
    }

    modal.addEventListener('click', function (e) {
      var capBtn = e.target.closest('[data-ins-caption-toggle]');
      if (capBtn && modal.contains(capBtn)) {
        e.preventDefault();
        var wrap = capBtn.closest('[data-ins-caption-wrap]');
        if (!wrap) return;
        wrap.classList.toggle('is-expanded');
        updateCaptionWrapState(wrap);
        return;
      }
      var playBtn = e.target.closest('[data-ins-modal-play]');
      if (playBtn && modal.contains(playBtn)) {
        onModalPlayClick(modal, playBtn);
        return;
      }
      var btn = e.target.closest('[data-ins-add-cart]');
      if (!btn || !modal.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      var vid = btn.getAttribute('data-variant-id');
      addToCart(vid, btn, root);
    });
  }

  function boot() {
    document.querySelectorAll('[data-ins-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target.querySelector('[data-ins-section]');
      if (sec) initSection(sec);
    });
  }
})();
